/*
 * Copyright Mimic Networks, Inc. 2025.
 */

import { ACLRule, GroupedActors } from './types';

export function groupRulesByActor(rules: ACLRule[]): GroupedActors {
  return rules.reduce((acc, rule) => {
    const actorKey = rule.actor?.split(': ')[1] || 'Unknown';
    const actorType = rule.actor?.split(': ')[0] || '';

    if (!acc[actorKey]) {
      acc[actorKey] = {
        type: actorType,
        rules: [],
      };
    }
    acc[actorKey].rules.push(rule);
    return acc;
  }, {} as GroupedActors);
}

export function getActorCount(rules: ACLRule[]): number {
  const actorGroups = groupRulesByActor(rules);
  return Object.keys(actorGroups).length;
}

export function cleanActorName(actor: string): string {
  if (actor === 'ANY') return actor;

  // Templatize drive GUIDs in actor names
  const cleanActor = actor
    .replace(/\\\\\?\\Volume\{[^}]+\}/g, '\\{drive}')
    .replace(/\\\\\?\\Volume\{[^}]+\}\\/g, '\\{drive}\\');

  return cleanActor.split('\\').pop() || cleanActor;
}

export function cleanResourcePath(resource: string): string {
  const resourcePath = resource.split(': ')[1] || resource;

  // Templatize Windows drive GUIDs
  return resourcePath
    .replace(/\\\\\?\\Volume\{[^}]+\}/g, '\\{drive}')
    .replace(/\\\\\?\\Volume\{[^}]+\}\\/g, '\\{drive}\\');
}
